import { Link } from "react-router-dom";

export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="vx-g" x1="0" y1="0" x2="40" y2="40">
        <stop offset="0" stopColor="#6366F1" />
        <stop offset="1" stopColor="#06B6D4" />
      </linearGradient>
    </defs>
    <rect width="40" height="40" rx="11" fill="#0B1329" />
    <rect width="40" height="40" rx="11" fill="url(#vx-g)" fillOpacity="0.14" />
    <rect x="0.75" y="0.75" width="38.5" height="38.5" rx="10.25" stroke="url(#vx-g)" strokeOpacity="0.6" strokeWidth="1.5" />
    <path d="M10 11.5 L20 29 L30 11.5 H25.4 L20 21.4 L14.6 11.5 Z" fill="url(#vx-g)" />
  </svg>
);

export const Logo = ({ testid = "nav-logo" }) => (
  <Link to="/" data-testid={testid} className="flex items-center gap-2.5 shrink-0" aria-label="VAELIX TECHNOLOGY home">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display font-extrabold tracking-tight text-lg text-foreground">VAELIX</span>
      <span className="block text-[9px] font-mono font-medium tracking-[0.32em] text-primary">TECHNOLOGY</span>
    </span>
  </Link>
);
